import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-back',
  templateUrl: './back.component.html',
  styleUrls: ['./back.component.css']
})
export class BackComponent implements OnInit {

  @Input() backUrl;
  constructor(private _router: Router) { }

  ngOnInit() {
  }

  public backToTheList() {
    this._router.navigate([this.backUrl]);
  }

}
